import { Domain } from '~/common/types';

export enum FilterCategory {
  PERSONAL = 'personal',
  DEFAULT = 'default',
}

export type Filter = {
  id: string;
  userId: string;
  name: string;
  domain: Domain;
  queryId: string;
  isFavorite: boolean;
};

export interface FiltersPropsShared {
  filters: Filter[];
  favoriteFilters: Filter[];
  favoriteFiltersMaxReached: boolean;
  selected?: Filter | undefined;
  onFilterDelete: (value: Filter) => void;
  onFilterToggleFavorites: (value: Filter) => void;
}
